import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDelete = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 24 24",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", { d: "M13 0h-2a3 3 0 00-3 3v1H2a1 1 0 000 2h1v14a4 4 0 004 4h10a4 4 0 004-4V6h1a1 1 0 000-2h-6V3a3 3 0 00-3-3zm-3 3a1 1 0 011-1h2a1 1 0 011 1v1h-4zm9 17a2 2 0 01-2 2H7a2 2 0 01-2-2V6h14z" }), /* @__PURE__ */ _jsx("path", { d: "M12 9a1 1 0 00-1 1v8a1 1 0 002 0v-8a1 1 0 00-1-1zM15 18a1 1 0 002 0v-8a1 1 0 00-2 0zM8 9a1 1 0 00-1 1v8a1 1 0 002 0v-8a1 1 0 00-1-1z" })]
});
export default SvgDelete;
